<template>
    <div class="com-container">
        <div class="login">
            <div class="title">{{ $t('login.desc1') }}</div>
            <div class="form">
                <PageNav :text="$t('login.desc73')" @back="handleBackClick" />
                <div class="tips">
                    {{ $t('login.desc74') }}
                </div>
                <div class="item">
                    <div class="name">{{ $t('login.desc65') }}</div>
                    <div class="inp-con">
                        <input class="inp" type="text" :placeholder="$t('login.desc75')" v-model="account" v-no-space />

                    </div>
                </div>


                <div class="btn" :class="{ active: account != '' }" @click="handleConfirm">{{
                    $t('login.desc8') }}</div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            account: ''
        }
    },
    mounted() {

    },
    methods: {
        handleBackClick() {
            this.$router.go(-1)
        },
        handleConfirm() {
            if (this.account != '') {
                this.$toast.loading({ forbidClick: true });
                this.$post(this.URL.login.getAccount, {
                    account: this.account
                }).then(res => {
                   if(res == null){
                    this.$toast(this.$t('login.desc76'))
                   }else if(res.lastLoginTime!=0){
                    this.$toast(this.$t('login.desc77'))
                   }else{
                    localStorage.setItem('account',this.account);
                    this.$router.push('/hvset')
                   }
                })

            }
        }
    }
}
</script>

<style lang="less" scoped>
.login {
    transform: translateY(-0.64rem);

    .title {
        padding: 0.4rem;
        box-sizing: border-box;
        border-radius: 0.16rem;
        background: #FFF;
        box-shadow: 0 0.04rem 0.28rem 0 rgba(0, 0, 0, 0.05);
        color: #382187;
        text-align: center;
        font-family: Poppins;
        font-size: 0.32rem;
        font-style: normal;
        font-weight: 700;
        line-height: 1.5em;
        /* 100% */
    }



    .form {
        margin: 0 auto;
        width: 7.04rem;

        .tips {
            color: #382187;
            font-family: Poppins;
            font-size: 0.18rem;
            font-style: normal;
            font-weight: 400;
            line-height: 0.2rem;
        }

        .item {
            margin-top: 0.4rem;
            display: flex;
            flex-direction: column;

            .name {
                color: #000;
                font-family: Poppins;
                font-size: 0.24rem;
                font-style: normal;
                font-weight: 500;
                line-height: 1.5em;
            }

            .inp-con {
                margin-top: 0.08rem;
                width: 100%;
                height: 0.42rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #EDEDED;
                color: #8644FF;
                font-family: Poppins;
                font-size: 0.16rem;
                font-weight: 400;

                .inp {
                    flex: 1;
                    width: 0;
                    height: 100%;
                    font-family: Poppins;
                    font-size: 0.16rem;
                    font-style: normal;
                    font-weight: 400;
                    display: flex;
                    align-items: center;
                    color: #8644FF;

                    &::placeholder {

                        color: #CACACA;
                    }
                }

                .eye {
                    flex: 0 0 auto;
                    margin-left: 0.2rem;
                    width: 0.22rem;
                    height: 0.22rem;
                    object-fit: contain;
                    cursor: pointer;
                }


            }


        }



        .btn {
            margin-top: 0.72rem;
            width: 100%;
            height: 0.6rem;
            color: #000;
            text-align: center;
            font-family: Poppins;
            font-size: 0.2rem;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            border-radius: 1rem;
            background: #E2E2E2;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;

            &.active {
                color: #fff;
                background: #8644FF;
            }

        }


    }
}

@media screen and (max-width: 768px) {
    .login {
        transform: translateY(-0.56rem);

        .title {
            padding: 0.2rem 0.5rem;
            font-size: 0.18rem;
            line-height: 0.24rem;
            border-radius: 0.08rem;
            font-weight: 700;
        }

        .form {
            width: 100%;
            padding: 0 0.12rem;

            .tips {
                font-size: 0.12rem;
                line-height: 0.16rem;
            }

            .item {
                margin-top: 0.3rem;

                .email {
                    &-title {
                        font-size: 0.14rem;


                    }
                }

                .name {
                    font-size: 0.14rem;
                }

                .inp-con {
                    margin-top: 0.01rem;

                    .inp {
                        font-size: 0.12rem;
                    }

                    .send-con {
                        font-size: 0.12rem;
                    }

                }
            }



            .btn {
                margin-top: 0.5rem;
                height: 0.48rem;
                font-size: 0.13rem;

            }


        }
    }
}
</style>